// extracted by mini-css-extract-plugin
module.exports = {"root":"gqDVI","icon":"rn0Vm","control":"FeKDc"};